import React, {useEffect} from 'react';
import Lightbox from "yet-another-react-lightbox";
import MetaTags from "../components/MetaTags";
import {useLocation} from "react-router-dom";

const Braslet = () => {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState<number>(0);
    // Получаем объект location
    const location = useLocation();
    // Получаем текущий путь
    const currentUrl = window.location.origin + location.pathname; // Получаем текущий URL
    useEffect(() => {
        document.title = "Браслеты из бисера";
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute("content", "Новое описание страницы");
        }
        const relCanonical = document.querySelector('link[rel="canonical"]');
        if (relCanonical) {
            relCanonical.setAttribute("href", currentUrl);
        }
    }, []); // Пустой массив зависимостей означает, что эффект выполнится только один раз при монтировании компонента

    const images = [
        {src: "/image/Braslet/kP1230111.jpg"},
        {src: "/image/Braslet/kP1230112.jpg"},
        {src: "/image/Braslet/kP2260145.jpg"},
        {src: "/image/Braslet/kP2260147.jpg"},
        {src: "/image/Braslet/kP2260150.jpg"},
        {src: "/image/Braslet/kP2260154.jpg"},
        {src: "/image/Braslet/kP2260155.jpg"},
        {src: "/image/Braslet/kP2260140.jpg"},
        {src: "/image/Braslet/kP2260141.jpg"},
        {src: "/image/Braslet/kP5150027.jpg"},
        {src: "/image/Braslet/kP5150026.jpg"},
        {src: "/image/Braslet/kP5150028.jpg"},
        {src: "/image/Braslet/kP5150023.jpg"},
        {src: "/image/Braslet/kP7060030.jpg"},
    ];

    const viewImage = (event: any) => {
        setOpen(true)
        setImage(Number(event.target.id.replace(/\D/g, '')))
    }

    MetaTags(
        "Браслеты из бисера",
        "Браслеты из бисера и стекляруса разных размеров. Браслеты в различных техниках - восьмерка, крестик, треугольная цепочка, сделаны из цветов и листиков."
    )

    return <>
        <h2>Браслеты из бисера</h2>
        <div className="row catalog">
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Braslet/mP1230111.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Браслет Огненный цветок"
                     id="image-0"
                     onClick={viewImage}
                />
                <p className="name">Браслет "Огненный цветок"</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Braslet/mP1230112.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Браслет Красный листик"
                     id="image-1"
                     onClick={viewImage}
                />
                <p className="name">Браслет "Красный листик"</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Braslet/mP2260145.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Браслет Восьмерка"
                     id="image-2"
                     onClick={viewImage}
                />
                <p className="name">Браслет "Восьмерка"</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Braslet/mP2260147.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Браслет Фактурный"
                     id="image-3"
                     onClick={viewImage}
                />
                <p className="name">Браслет "Фактурный"</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Braslet/mP2260150.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Браслет Полосатый"
                     id="image-4"
                     onClick={viewImage}
                />
                <p className="name">Браслет "Полосатый"</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Braslet/mP2260154.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Браслет с сердоликом"
                     id="image-5"
                     onClick={viewImage}
                />
                <p className="name">Браслет с сердоликом</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Braslet/mP2260155.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Браслет Трехцветный"
                     id="image-6"
                     onClick={viewImage}
                />
                <p className="name">Браслет "Трехцветный"</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Braslet/mP2260140.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Ажурный браслет"
                     id="image-7"
                     onClick={viewImage}
                />
                <p className="name">Ажурный браслет</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Braslet/mP2260141.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Браслет Змейка"
                     id="image-8"
                     onClick={viewImage}
                />
                <p className="name">Браслет "Змейка"</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Braslet/mP5150027.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Браслет крестиком"
                     id="image-9"
                     onClick={viewImage}
                />
                <p className="name">Браслет крестиком</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Braslet/mP5150026.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Браслет Треугольнички"
                     id="image-10"
                     onClick={viewImage}
                />
                <p className="name">Браслет "Треугольнички"</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Braslet/mP5150028.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Браслет крестиком"
                     id="image-11"
                     onClick={viewImage}
                />
                <p className="name">Браслет крестиком</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Braslet/mP5150023.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Браслет Солнечный цветок"
                     id="image-12"
                     onClick={viewImage}
                />
                <p className="name">Браслет "Солнечный цветок"</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Braslet/mP7060030.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Браслет в народном стиле"
                     id="image-13"
                     onClick={viewImage}
                />
                <p className="name">Браслет в народном стиле</p>
            </div>
        </div>


        <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={[
                images[image], // Выбранный элемент
                ...images.slice(0, image), // Элементы до выбранного
                ...images.slice(image + 1) // Элементы после выбранного
            ]}
        />
    </>;
};

export default Braslet;

